// src/theme.js
const theme = {
  colors: {
    primary: '#1e3a8a',      // Dark blue
    secondary: '#3b82f6',    // Medium blue
    accent: '#60a5fa',       // Light blue
    background: '#f0f9ff',   // Very light blue background
    text: '#1e293b',         // Dark text
    lightText: '#64748b',    // Light text
    white: '#ffffff',
  },
  fonts: {
    main: "'Poppins', 'Segoe UI', system-ui, sans-serif",
    heading: "'Montserrat', 'Segoe UI', system-ui, sans-serif",
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    laptop: '992px',
    desktop: '1200px',
  },
  typography: {
    h1: {
      fontSize: '4rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '3rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 600,
      lineHeight: 1.3,
    },
    body: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
  shadows: {
    small: '0 2px 8px rgba(0, 0, 0, 0.1)',
    medium: '0 5px 15px rgba(0, 0, 0, 0.07)',
    large: '0 10px 25px rgba(0, 0, 0, 0.1)',
  }
};

export default theme;